<template>
    <div class="spinner-wrapper">
        <span v-if="loadingMessage" class="loading-message">
            {{ `${loadingMessage}...` }}
        </span>
        <img class="spinner" src="@/assets/loader.svg" />
    </div>
</template>

<script setup lang="ts">
    import { toRefs } from "vue";

    const props = defineProps<{
        loadingMessage?: string;
    }>();

    const { loadingMessage } = toRefs(props);
</script>

<style lang="scss">
    @import "@/style/variables";

    .spinner-wrapper {
        z-index: 5;
        left: 50%;
        top: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;

        .loading-message {
            height: fit-content;
            color: $color-dark;
            background-color: $color-grey-bg;
            border-radius: $border-radius-max;
            padding: 0.5rem;
            box-shadow: $box-shadow-floating-button;
        }

        .spinner {
            animation: spin 4s linear infinite;
            width: 150px;
            height: 150px;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
</style>
